import { Modal, Table, Button } from '@mantine/core';
import moment from 'moment';
import "./DeliveryScheduleModal.css";

const DeliveryScheduleModal = ({ opened, onClose, orderType, purchaseOrder }) => {
  const schedules =
    (purchaseOrder && purchaseOrder.stockSchedules && purchaseOrder.stockSchedules.length > 0)
      ? purchaseOrder.stockSchedules
      : (purchaseOrder && purchaseOrder.items && purchaseOrder.items.length > 0)
        ? purchaseOrder.items.map((it, idx) => ({
          id: it.id ?? `item-${idx}`,
          productName: it.productName,
          createdDate: it.createdDate ?? it.createdAt ?? null,
          qty: it.qty ?? 0,
          orderedRolls: it.orderedRolls ?? it.noOfRollOrdered ?? 0,
          stdKg: it.stdKg ?? purchaseOrder?.stdKg ?? 20,
          fabricQty: it.fabricQty ?? null,
          noOfFabricRolls: it.noOfFabricRolls ?? null,
          fabricDeliveryDate: it.fabricDeliveryDate ?? null,
          fabricDispatchDate: it.fabricDispatchDate ?? null,
          dyeLotQty: it.dyeLotQty ?? null,
          noOfDyeLotRolls: it.noOfDyeLotRolls ?? null,
          dyeLotDeliveryDate: it.dyeLotDeliveryDate ?? null,
          dyeLotDispatchDate: it.dyeLotDispatchDate ?? null,
          greigeQty: it.greigeQty ?? null,
          noOfGreigeRolls: it.noOfGreigeRolls ?? null,
          greigeDeliveryDate: it.greigeDeliveryDate ?? null,
          greigeDispatchDate: it.greigeDispatchDate ?? null,
          costPrice: it.costPrice ?? null,
          deliveryDate: it.deliveryDate ?? null,
          dispatchDate: it.dispatchDate ?? null,
          productVariantName: it.productName || it.productVariant?.name || "",
          originalItem: it,
        }))
        : [];

  return (
    <Modal opened={opened} onClose={onClose} title="Delivery Schedule" size={orderType === 'WHOLESALE' ? '100%' : '80%'} centered>
      {schedules.length === 0 ? (
        <Text>No data available</Text>
      ) : (
        <>
          {schedules.map((schedule) => {
            const findByVariantSku = (sku) =>
              (purchaseOrder?.items || []).find(i => i.variantSku && sku && i.variantSku === sku);

            const findBySwatchId = (swatchId) =>
              (purchaseOrder?.items || []).find(i => i.swatchId && swatchId && i.swatchId === swatchId);

            const matchedItem =
              schedule.originalItem ||
              findByVariantSku(schedule.variantSku) ||
              findBySwatchId(schedule.swatchId) ||
              {};

            const rows = [
              {
                sl: 1,
                key: 'fabric',
                status: 'Finished Fabric',
                qty: schedule?.fabricQty ?? '-',
                rolls: schedule?.noOfFabricRolls ?? '-',
                leadTime: matchedItem?.fabricLeadTime ?? matchedItem?.fabricLeadTimeInDays ?? '-',
                deliveryDate: schedule?.fabricDeliveryDate ? moment(schedule.fabricDeliveryDate).format('DD/MM/YYYY') : '-',
                dispatchDate: schedule?.fabricDispatchDate ? moment(schedule.fabricDispatchDate).format('DD/MM/YYYY') : '-',
              },
              {
                sl: 2,
                key: 'dyeLot',
                status: 'Dye Lot',
                qty: schedule?.dyeLotQty ?? '-',
                rolls: schedule?.noOfDyeLotRolls ?? '-',
                leadTime: matchedItem?.dyeLotLeadTime ?? matchedItem?.dyeLotLeadTimeInDays ?? '-',
                deliveryDate: schedule?.dyeLotDeliveryDate ? moment(schedule.dyeLotDeliveryDate).format('DD/MM/YYYY') : '-',
                dispatchDate: schedule?.dyeLotDispatchDate ? moment(schedule.dyeLotDispatchDate).format('DD/MM/YYYY') : '-',
              },
              {
                sl: 3,
                key: 'greige',
                status: 'Greige',
                qty: schedule?.greigeQty ?? '-',
                rolls: schedule?.noOfGreigeRolls ?? '-',
                leadTime: matchedItem?.greigeLeadTime ?? matchedItem?.greigeLeadTimeInDays ?? '-',
                deliveryDate: schedule?.greigeDeliveryDate ? moment(schedule.greigeDeliveryDate).format('DD/MM/YYYY') : '-',
                dispatchDate: schedule?.greigeDispatchDate ? moment(schedule.greigeDispatchDate).format('DD/MM/YYYY') : '-',
              },
            ];
            return (
              <div key={schedule.id || schedule.variantSku || Math.random()} style={{ marginBottom: 24 }}>
                <Table withBorder withColumnBorders className="delivery-schedule-table" style={{ marginBottom: 8 }}>
                  <Table.Tbody>
                    <Table.Tr>
                      <Table.Td><b>Line Item</b></Table.Td>
                      <Table.Td>{matchedItem?.productName}</Table.Td>
                      <Table.Td><b>Date</b></Table.Td>
                      <Table.Td>{schedule.createdDate ? moment(schedule.createdDate).format('DD/MM/YYYY') : '-'}</Table.Td>
                    </Table.Tr>

                    <Table.Tr>
                      <Table.Td><b>PO Qty</b></Table.Td>
                      <Table.Td>{schedule.qty ?? schedule.qty === 0 ? schedule.qty : '-'}</Table.Td>

                      {orderType === 'WHOLESALE' ? (
                        <>
                          <Table.Td><b>PO Rolls</b></Table.Td>
                          <Table.Td>{schedule.orderedRolls ?? schedule.noOfRollOrdered ?? '-'}</Table.Td>
                        </>
                      ) : (
                        <>
                          <Table.Td><b>Cost Price</b></Table.Td>
                          <Table.Td>{schedule.costPrice != null ? Number(schedule.costPrice).toFixed(2) : '-'}</Table.Td>
                        </>
                      )}
                    </Table.Tr>

                    <Table.Tr>
                      {orderType === 'WHOLESALE' ? (
                        <>
                          <Table.Td><b>Qty/Roll</b></Table.Td>
                          <Table.Td>{schedule.stdKg ?? purchaseOrder?.stdKg ?? '-'}</Table.Td>
                          <Table.Td><b>Deliverable Rolls</b></Table.Td>
                          <Table.Td>{(schedule?.noOfDyeLotRolls + schedule?.noOfFabricRolls + schedule?.noOfGreigeRolls )}</Table.Td>
                         

                        </>
                      ) : (
                        <>
                          <Table.Td><b>Delivery Date</b></Table.Td>
                          <Table.Td>{schedule.deliveryDate ? moment(schedule.deliveryDate).format('DD/MM/YYYY') : '-'}</Table.Td>
                          <Table.Td><b>Dispatch Date</b></Table.Td>
                          <Table.Td>{schedule.dispatchDate ? moment(schedule.dispatchDate).format('DD/MM/YYYY') : '-'}</Table.Td>
                        </>
                      )}
                    </Table.Tr>
                        <Table.Tr>
                      {orderType === 'WHOLESALE' ? (
                        <>
            
                          <Table.Td><b>Cost Price</b></Table.Td>
                          <Table.Td>{schedule.costPrice != null ? Number(schedule.costPrice).toFixed(2): '-'}</Table.Td>
                            <Table.Td><b>Pending Rolls</b></Table.Td>
                         <Table.Td>{(schedule?.noOfRollOrdered)-(schedule?.noOfDyeLotRolls + schedule?.noOfFabricRolls + schedule?.noOfGreigeRolls )}</Table.Td>

                        </>
                      ) : (
                        <>
                        
                        </>
                      )}
                    </Table.Tr>
                  </Table.Tbody>
                </Table>

                {orderType === 'WHOLESALE' && <Table striped withBorder withColumnBorders className="delivery-schedule-table">
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>Sl. No.</Table.Th>
                      <Table.Th>Production Status</Table.Th>
                      {orderType === 'WHOLESALE' && <Table.Th>Rolls</Table.Th>}
                      <Table.Th>Quantity</Table.Th>
                      {orderType === 'WHOLESALE' && <Table.Th>Lead Time</Table.Th>}
                      <Table.Th>Delivery Date</Table.Th>
                      <Table.Th>Dispatch Date</Table.Th>
                    </Table.Tr>
                  </Table.Thead>

                  <Table.Tbody>
                    {rows.map(row => (
                      <Table.Tr key={row.sl}>
                        <Table.Td>{row.sl}</Table.Td>
                        <Table.Td>{row.status}</Table.Td>

                        {orderType === 'WHOLESALE' && <Table.Td>{row.rolls}</Table.Td>}

                        <Table.Td>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span>{row.qty}</span>
                            {orderType === 'WHOLESALE' && <small style={{ color: '#555' }}>{(row.rolls === '-' ? '-' : `${row.rolls}`)} Roll x {schedule.stdKg ?? purchaseOrder?.stdKg ?? 20} Kgs</small>}
                          </div>
                        </Table.Td>

                        {orderType === 'WHOLESALE' && <Table.Td>{row.leadTime}</Table.Td>}

                        <Table.Td>{row.deliveryDate}</Table.Td>
                        <Table.Td>{row.dispatchDate}</Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.Tbody>
                </Table>}
              </div>
            );
          })}
        </>
      )}

      <Button onClick={onClose} mt="md" color="#8BC53F">Close</Button>
    </Modal>
  );
};

export default DeliveryScheduleModal;
